import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useConfig, useCurrentUser, usePusher, } from '@marvelapp/ballpark-application';
import { PusherEvent } from '@marvelapp/core';
const GET_PROJECT_LIVE_SESSIONS_COUNT = gql `
  query getProjectLiveSessionsCount($pk: Int) {
    userTest(pk: $pk) {
      pk
      liveSessionsCount
    }
  }
`;
export function useLiveProjectSessionsCount(projectPk) {
    var _a, _b;
    const { data, refetch } = useQuery(GET_PROJECT_LIVE_SESSIONS_COUNT, {
        variables: { pk: projectPk },
    });
    const config = useConfig();
    const user = useCurrentUser();
    const { pusher } = usePusher();
    useEffect(() => {
        const channelName = `${config.pusher.userChannelPrefix}${user.pk}`;
        const { bindChannel } = pusher.subscribe(channelName);
        const handleSessionStarted = (eventData) => {
            if (eventData.content.usertest_pk === projectPk) {
                refetch();
            }
        };
        const handleSessionEnded = (eventData) => {
            if (eventData.content.usertest_pk === projectPk) {
                refetch();
            }
        };
        // Refetch count when a new live session starts
        const unbindSessionStarted = bindChannel(PusherEvent.LiveSessionStarted, handleSessionStarted);
        // Refetch count when a live session is ended
        const unbindSessionEnded = bindChannel(PusherEvent.LiveSessionEnded, handleSessionEnded);
        return () => {
            unbindSessionStarted();
            unbindSessionEnded();
        };
    }, [config.pusher.userChannelPrefix, pusher, user.pk, refetch, projectPk]);
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.userTest) === null || _a === void 0 ? void 0 : _a.liveSessionsCount) !== null && _b !== void 0 ? _b : 0;
}
